const firebaseConfig = {
    apiKey: "AIzaSyBLwIT9iq055eetMHwi9PXO89-RWkz7QtU",
    authDomain: "servicing-center.firebaseapp.com",
    projectId: "servicing-center",
    storageBucket: "servicing-center.appspot.com",
    messagingSenderId: "402648160039",
    appId: "1:402648160039:web:829b5f21de51695eebfb02",
    measurementId: "G-SLL1GL9SNY"
}

export default firebaseConfig;